module.exports = __webpack_public_path__ + "img/banner3.8c0544c1.png";